'use client';

import CollageImage from './CollageImage';
import CollageVideo from './CollageVideo';

const Collage = ({ content, background = '#fff', className, unoptimize = true, altText }: any) => {
  return (
    <div className="-mt-5 overflow-hidden md:mb-5">
      <div className={`banner relative items-center justify-center ${className}`}>
        <div className="relative z-10 grid md:aspect-[2/1]">
          <div className="banner-text flex">
            <div className="w-full">{content.children}</div>
          </div>
          <div className="banner-image">
            <div className="relative z-20 overflow-hidden">
              <CollageImage source={content.image} unoptimize={unoptimize} alt={altText} />
            </div>
          </div>
          <div className="banner-video mt-5 md:h-full">
            <div className="relative h-full overflow-hidden max-md:aspect-square md:h-full">
              <CollageVideo source={content.video} />
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .banner {
          --gutter: 30px;
        }
        .banner:before {
          content: '';
          background-color: transparent;
          position: absolute;
          width: 100vw;
          top: calc(var(--gutter) + 5px);
          bottom: calc(calc(var(--gutter) - 20px) * 4);
          left: 50%;
          transform: translateX(-50%);
        }
        .grid {
          grid-template-rows: auto;
          grid-template-columns: 1fr;
          grid-template-areas:
            'video'
            'text'
            'image';
        }
        .banner-text {
          text-align: center;
          grid-area: text;
          padding-top: 1.166667rem;
          padding-bottom: 2rem;
        }
        .banner-image {
          grid-area: image;
        }
        .banner-image > div {
          width: 100%;
          aspect-ratio: 540/273;
        }
        .banner-video {
          grid-area: video;
        }
        @media (min-width: 768px) {
          .banner:before {
            background-color: ${background};
          }

          .grid {
            grid-template-rows: repeat(2, 2fr);
            grid-template-columns: repeat(2, 2fr);
            grid-template-areas:
              'text video'
              'image video';
          }

          .banner-text {
            text-align: left;
            padding-bottom: calc(var(--gutter) / 2);
          }
          .banner-text > div {
            padding: calc(var(--gutter) / 2);
            padding-left: 0;
          }

          .banner-image > div {
            width: calc(100% + var(--gutter) / 2);
            height: calc(100% + calc(var(--gutter) / 2));
            top: calc(0px - var(--gutter) / 2);
          }
        }
        @media (min-width: 991px) {
          .banner {
            --gutter: 40px;
          }
          .banner-image > div {
            height: calc(100% - calc(var(--gutter) / 4));
            top: calc(0px - var(--gutter) / 2 - 6px);
          }
        }
      `}</style>
    </div>
  );
};

export default Collage;
